/* src/app/features/taxas-juros/janelas-apuracao/janelas-apuracao-listagem.component.scss */
.line {
  text-decoration: line-through;
}
/*# sourceMappingURL=janelas-apuracao-listagem.component.css.map */
